module.exports = __webpack_public_path__ + "media/Video 9.b92b6867.mp4";